import { render, staticRenderFns } from "./ContactTemplate.vue?vue&type=template&id=140281e4"
import script from "./ContactTemplate.vue?vue&type=script&lang=ts"
export * from "./ContactTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports